/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { riskPoliciesCreate } from "../funcs/riskPoliciesCreate.js";
import { riskPoliciesDelete } from "../funcs/riskPoliciesDelete.js";
import { riskPoliciesGet } from "../funcs/riskPoliciesGet.js";
import { riskPoliciesList } from "../funcs/riskPoliciesList.js";
import { riskPoliciesListForMcpServer } from "../funcs/riskPoliciesListForMcpServer.js";
import { riskPoliciesListMcpPlatformToolsets } from "../funcs/riskPoliciesListMcpPlatformToolsets.js";
import { riskPoliciesTrigger } from "../funcs/riskPoliciesTrigger.js";
import { riskPoliciesUpdate } from "../funcs/riskPoliciesUpdate.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListMCPPlatformToolsetsResult } from "../models/components/listmcpplatformtoolsetsresult.js";
import { ListRiskPoliciesResult } from "../models/components/listriskpoliciesresult.js";
import { RiskPolicy } from "../models/components/riskpolicy.js";
import {
  CreateRiskPolicyRequest,
  CreateRiskPolicySecurity,
} from "../models/operations/createriskpolicy.js";
import {
  DeleteRiskPolicyRequest,
  DeleteRiskPolicySecurity,
} from "../models/operations/deleteriskpolicy.js";
import {
  GetRiskPolicyRequest,
  GetRiskPolicySecurity,
} from "../models/operations/getriskpolicy.js";
import {
  ListMCPPlatformToolsetsRequest,
  ListMCPPlatformToolsetsSecurity,
} from "../models/operations/listmcpplatformtoolsets.js";
import {
  ListRiskPoliciesRequest,
  ListRiskPoliciesSecurity,
} from "../models/operations/listriskpolicies.js";
import {
  ListRiskPoliciesForMcpServerRequest,
  ListRiskPoliciesForMcpServerSecurity,
} from "../models/operations/listriskpoliciesformcpserver.js";
import {
  TriggerRiskAnalysisRequest,
  TriggerRiskAnalysisSecurity,
} from "../models/operations/triggerriskanalysis.js";
import {
  UpdateRiskPolicyRequest,
  UpdateRiskPolicySecurity,
} from "../models/operations/updateriskpolicy.js";
import { unwrapAsync } from "../types/fp.js";

export class Policies extends ClientSDK {
  /**
   * createRiskPolicy risk
   *
   * @remarks
   * Create a new risk analysis policy for the current project.
   */
  async create(
    request: CreateRiskPolicyRequest,
    security?: CreateRiskPolicySecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskPolicy> {
    return unwrapAsync(riskPoliciesCreate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteRiskPolicy risk
   *
   * @remarks
   * Delete a risk analysis policy.
   */
  async delete(
    request: DeleteRiskPolicyRequest,
    security?: DeleteRiskPolicySecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(riskPoliciesDelete(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getRiskPolicy risk
   *
   * @remarks
   * Get a risk analysis policy by ID.
   */
  async get(
    request: GetRiskPolicyRequest,
    security?: GetRiskPolicySecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskPolicy> {
    return unwrapAsync(riskPoliciesGet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listMCPPlatformToolsets risk
   *
   * @remarks
   * List code-owned Platform MCP toolsets available as risk policy scope targets.
   */
  async listMcpPlatformToolsets(
    request?: ListMCPPlatformToolsetsRequest | undefined,
    security?: ListMCPPlatformToolsetsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListMCPPlatformToolsetsResult> {
    return unwrapAsync(riskPoliciesListMcpPlatformToolsets(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listRiskPolicies risk
   *
   * @remarks
   * List all risk analysis policies for the current project.
   */
  async list(
    request?: ListRiskPoliciesRequest | undefined,
    security?: ListRiskPoliciesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListRiskPoliciesResult> {
    return unwrapAsync(riskPoliciesList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listRiskPoliciesForMcpServer risk
   *
   * @remarks
   * List enabled MCP-scoped risk policies that apply to an MCP server and optional tool. Policies without an MCP scope are excluded.
   */
  async listForMcpServer(
    request: ListRiskPoliciesForMcpServerRequest,
    security?: ListRiskPoliciesForMcpServerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListRiskPoliciesResult> {
    return unwrapAsync(riskPoliciesListForMcpServer(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * triggerRiskAnalysis risk
   *
   * @remarks
   * Manually trigger risk analysis for a policy, starting or signaling the drain workflow. Defaults to the most recent 100 unanalyzed messages; pass `limit=0` to backfill every unanalyzed message.
   */
  async trigger(
    request: TriggerRiskAnalysisRequest,
    security?: TriggerRiskAnalysisSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(riskPoliciesTrigger(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateRiskPolicy risk
   *
   * @remarks
   * Update a risk analysis policy.
   */
  async update(
    request: UpdateRiskPolicyRequest,
    security?: UpdateRiskPolicySecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskPolicy> {
    return unwrapAsync(riskPoliciesUpdate(
      this,
      request,
      security,
      options,
    ));
  }
}
